class EditProductController {
  constructor(
    product,
    lessonPlans,
    roadmaps,
    FlashService,
    ProductsModel,
    $state,
    OnlineDriversEdConfig,
  ) {
    this.FlashService = FlashService;
    this.ProductsModel = ProductsModel;
    this.product = product;
    this.$state = $state;
    this.lessonPlans = lessonPlans;
    this.OnlineDriversEdConfig = OnlineDriversEdConfig;
    this.displayLessonPlanType = this.displayLessonPlanType.bind(this);

    this.lessonPlans.forEach((plan) => {
      if (product.lesson_plan && product.lesson_plan.id === plan.id) {
        this.product.lesson_plan = plan;
      }
    });

    this.roadmaps = roadmaps;
    this.preserveActiveRoadmap = !!(
      product.roadmap &&
      product.roadmap.pivot &&
      product.roadmap.pivot.preserve_active_roadmap
    );

    // Ensure document_templates is initialized
    if (!this.product.document_templates) {
      this.product.document_templates = [];
    }

    this.editProduct = this.editProduct.bind(this);
  }

  displayLessonPlanType(type) {
    if (type === "course_type") {
      return "Course Type";
    }
    if (type === "session_type") {
      return "Session Type";
    }
    if (type === "permit") {
      return "Permit";
    }
    return "";
  }

  addLessonPlan() {
    this.product.lesson_plan = this.lessonPlan;
  }

  removeLessonPlan() {
    delete this.product.lesson_plan;
  }

  addRoadmap() {
    this.product.roadmap = this.roadmap;
    this.preserveActiveRoadmap = false;
  }

  removeRoadmap() {
    this.product.roadmap = null;
  }

  editProduct(formValid, form) {
    form.submitting = true;
    const product = {
      id: this.product.id,
      product_name: this.product.name,
      product_price: this.product.price * 100,
      product_sku: this.product.sku,
      session_types: this.product.sessiontypes,
      course_types: this.product.coursetypes,
      disabled: this.product.disabled,
      product_description: this.product.description,
      categories: this.product.categories,
      document_templates: this.product.document_templates,
      product_sequence: this.product.sequence,
      purchasable: this.product.purchasable,
      purchase_instructions: this.product.purchase_instructions,
      allow_partial_payment: this.product.allow_partial_payment,
      can_schedule_lessons_during_checkout:
        this.product.can_schedule_lessons_during_checkout,
      deposit_required: this.product.deposit_required,
      deposit_type: this.product.deposit_type,
      deposit_amount: this.product.deposit_amount,
      minimum_payment_amount: this.product.minimum_payment_amount,
    };
    if (this.product.lesson_plan && this.product.lesson_plan !== null) {
      product.lesson_plan = {
        id: this.product.lesson_plan.id,
      };
    }

    if (this.product.roadmap && this.product.roadmap !== null) {
      product.roadmap = {
        id: this.product.roadmap.id,
        preserve_active_roadmap: this.preserveActiveRoadmap === true,
      };
    }

    if (this.OnlineDriversEdConfig.enabled === true) {
      product.is_ode = this.product.is_ode;
    }

    this.ProductsModel.update(product)
      .then((response) => {
        form.submitting = false;
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.$state.go("drivecoach.admin.products", {}, { reload: true });
      })
      .catch((response) => {
        form.submitting = false;
      });
  }
}

EditProductController.$inject = [
  "product",
  "lessonPlans",
  "roadmaps",
  "FlashService",
  "ProductsModel",
  "$state",
  "OnlineDriversEdConfig",
];
export default EditProductController;
